import { render, staticRenderFns } from "./move-table.vue?vue&type=template&id=1bf1d61e&scoped=true&"
import script from "./move-table.vue?vue&type=script&lang=js&"
export * from "./move-table.vue?vue&type=script&lang=js&"
import style0 from "./move-table.vue?vue&type=style&index=0&id=1bf1d61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1d61e",
  null
  
)

export default component.exports